import React from 'react';
import {gql} from '@apollo/client';
import {get} from 'lodash';

import client from '../../../src/graphql/client';

// queries
import contentBuilderQuery from '../../../src/graphql/queries/content-builder';
import seoQuery from '../../../src/graphql/queries/seo';

// refactor
import refactorBreadcrumbsData from '../../../src/data-restructure/navigation/breadcrumbs/breadcrumbs';
import refactorRangeLandingPageData from '../../../src/data-restructure/pages/range/range-landing-page';

// components
import ContentBuilder from '../../../src/containers/ContentBuilder';

const CaravanCategory = (props) => {

  // const handleNextClick = () => {
  //   dlPush({
  //     'event': 'jaycoEvent',
  //     'eventAction': 'CTA Click - Our Range - Compare',
  //     'eventCategory': 'Research',
  //     'eventLabel': 'Next'
  //   })
  // }

  // console.info('range page props', props);

  return (
    <>

      {props.contentBuilder &&
        <ContentBuilder
          data={props.contentBuilder.filter(item => {
            return !process.env.DEALER_SITE || process.env.DEALER_SITE && item.type !== 'quicklinks' ? true : false
          })}
          countryProps={props.countryProps}
        />
      }

      {/* <>
        {process.env.DEALER_SITE &&
          <Quicklinks 
            dealerComponent={true}
          />
        }
      </> */}

    </>

  )
}

export default CaravanCategory;

export async function getStaticPaths() {

  const GET_DYNAMIC_PATHS_QUERY = gql`
    query GET_DYNAMIC_PATHS {
      ranges(first: 1000) {
        nodes {
          uri
          acf_domains {
            assignedDomains
          }
        }
      }
    }
  `

  const result = await client.query({
    query: GET_DYNAMIC_PATHS_QUERY
  });

  const ranges = get(result, 'data.ranges.nodes', []);
  let paths = [];
  
  const filteredRanges = ranges.filter((item) => {
    // filter out if doesn't have uri
    return item.uri
  });
  
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const domain = countryCode === 'au' ? 'jayco.com.au' : 'jayco.co.nz';

  filteredRanges.forEach(range => {
    const assignedDomains = get(range, 'acf_domains.assignedDomains', []);
    assignedDomains.indexOf(domain) !== -1 && paths.push({
      params: {
        range: `${range.uri}`
      }
    });
  })

  return { paths , fallback: 'blocking' }
}


export async function getStaticProps(context) {
  const countryCode = process.env.DEV_COUNTRY_CODE ? process.env.DEV_COUNTRY_CODE.toLowerCase() : process.env.COUNTRY_CODE.toLowerCase();
  const {
    params
  } = context

  const GET_DYNAMIC_RANGE_PROPS = gql`
    query GET_RANGE_DATA($uri: String) {
      rangeBy(uri: $uri) {
        id
        title
        seo {
          ${seoQuery}
        }
        ${contentBuilderQuery('Range_AcfContentBuilder')}
        acf_domains {
          assignedDomains
        }
      }
    }
  `
  const pageProps = await client.query({
    query: GET_DYNAMIC_RANGE_PROPS,
    variables: {
      uri: params.range
    }
  });

  const data = await refactorRangeLandingPageData(pageProps, params)

  // seo
  const title = get(pageProps, 'data.rangeBy.title', null);
  const seo = get(pageProps, 'data.rangeBy.seo', null);
  const assignedDomains = get(pageProps, 'data.rangeBy.acf_domains.assignedDomains', []); 

  // breadcrumbs
  const rangeUrl = `/range/${params.range}`;
  data.breadcrumbs = await refactorBreadcrumbsData(rangeUrl, assignedDomains);

  data.meta = {
    title,
    seo,
    assignedDomains
  };
  
  return {
    revalidate: (process.env.NEXT_STATIC_EXPORT && process.env.NEXT_STATIC_EXPORT.toString() === 'true') ? false : 1,
    props: {
     ...data,
    }
  }
}
